import { CachePolicy } from 'contentstack';
import { unstable_cache } from 'next/cache';

import {
    ContentStack,
    ContentStackLivePreview,
} from '@nxt-costco-com/forge-digital-components';
import type {
    ContentTypeProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

const _findAllWhere = async function _findAllWhere<T>(
    contentType: ContentTypeProps,
    key: string,
    value: string,
    enableLivePreview: boolean,
    lang: LocaleProps,
    limit?: number,
): Promise<T> {
    let stackClient = ContentStack;

    if (enableLivePreview) {
        stackClient = ContentStackLivePreview;
        stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
    }

    try {
        let query = stackClient.stack
            .ContentType(contentType)
            .Query()
            .language(lang)
            .where(key, value)
            .toJSON();

        if (limit) {
            query = query.limit(limit);
        }

        const result = await query.find();

        if (limit === 1) {
            return result?.[0]?.[0] as T;
        } else {
            return result as T;
        }
    } catch (err) {
        throw new Error(
            `An error occurred in _findAllWhere: ${JSON.stringify(err)}`,
        );
    }
};

const cached_findAllWhere = unstable_cache(
    _findAllWhere,
    ['search_findAllWhere'],
    {
        revalidate: 1800,
    },
);

export const findAllWhere = async function findAllWhere<T>(
    contentType: ContentTypeProps,
    key: string,
    value: string,
    enableLivePreview: boolean,
    lang: LocaleProps,
    limit?: number,
): Promise<T> {
    const fn =
        typeof window === 'undefined' ? cached_findAllWhere : _findAllWhere;

    return fn(contentType, key, value, enableLivePreview, lang, limit);
};
